import React from "react";
import { motion } from "framer-motion";

const STEPS = [
    {
        n: "01",
        title: "Discuss",
        desc: "We understand your business, requirement and objective — over WhatsApp, a call or in person.",
    },
    {
        n: "02",
        title: "Create",
        desc: "We develop concepts and design directions built on strategy, not templates.",
    },
    {
        n: "03",
        title: "Approve",
        desc: "You pick a direction. We refine and finalise it with your feedback until it's right.",
    },
    {
        n: "04",
        title: "Deliver",
        desc: "You receive production-ready artwork — or the finished printed and installed material.",
    },
];

export const ProcessSection = () => (
    <section
        data-testid="process-section"
        className="relative py-24 sm:py-32 bg-[#050505] border-t border-white/5"
    >
        <div className="max-w-7xl mx-auto px-6 md:px-12">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.6 }}
                className="max-w-2xl mb-16"
            >
                <div className="font-inter text-xs uppercase tracking-[0.25em] text-gold mb-4">
                    How We Work
                </div>
                <h2 className="font-poppins font-semibold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
                    A simple process. <span className="gold-gradient-text">A serious result.</span>
                </h2>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-white/10">
                {STEPS.map((s, i) => (
                    <motion.div
                        key={s.n}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.55, delay: i * 0.08 }}
                        data-testid={`process-step-${s.n}`}
                        className="group relative border-b lg:border-b-0 lg:border-r border-white/10 last:border-r-0 p-8 lg:p-10 hover:bg-white/[0.02] transition-colors"
                    >
                        <div className="font-poppins font-bold text-6xl lg:text-7xl text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.4)] group-hover:[-webkit-text-stroke:1px_rgba(212,175,55,0.9)] transition-all mb-8">
                            {s.n}
                        </div>
                        <h3 className="font-poppins font-medium text-white text-xl mb-3">
                            {s.title}
                        </h3>
                        <p className="font-inter text-sm text-zinc-400 leading-relaxed">
                            {s.desc}
                        </p>
                        <div className="mt-8 h-px w-8 bg-gold/40 group-hover:w-full transition-all duration-500" />
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default ProcessSection;
